import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatExpectedArrivalDate, formatExpectedArrivalDateOrdinal, getAlmostSoldOutText, getAlmostSoldOutTooltipText } from '../utils/utils';
import PreOrderBlock from './PreOrderBlock';

const ProductStatus = ({ product, isWishlistPage = false, isBasket = false }) => {
  if (product === undefined) {
    return null;
  }

  const styleClass = isBasket ? 'm-0' : (isWishlistPage ? 'm-0' : 'small pb-2');
  const fontSizeClass = isBasket ? '' : '';

  if (product.quantity > 0 && product.state === 'SOLD_OUT' && !isWishlistPage) {
    if (isBasket) {
      return null;
    }
    const soldOutBadgeLineClass = styleClass.replace(/\bpb-2\b/g, '').trim();
    return (
      <div className='row pl-3 pb-2'>
        <p className={`${soldOutBadgeLineClass} text-success font-weight-bold mb-0`}>Є в наявності
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>Товар в наявності на нашому складі, відправка протягом 1 робочого дня</strong>
          </Tooltip>}>
            <i className='bi bi-info-circle px-1' />
          </OverlayTrigger>
        </p>
        <p className={`${soldOutBadgeLineClass} text-info font-weight-bold mb-0`}>Останні набори
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>В наявності останні набори. Товар знятий з продажу і більше не буде поставлятись</strong>
          </Tooltip>}>
            <i className='bi bi-info-circle px-1' />
          </OverlayTrigger>
        </p>
        {product.quantity <= 3 && (() => {
          const t = getAlmostSoldOutText(product.quantity);
          const lastSpace = t.lastIndexOf(' ');
          const beforeLastWord = lastSpace >= 0 ? t.slice(0, lastSpace + 1) : '';
          const lastWord = lastSpace >= 0 ? t.slice(lastSpace + 1) : t;
          return (
            <p className={`${soldOutBadgeLineClass} text-warning font-weight-bold mb-0 mt-0`}>
              {beforeLastWord}
              <span style={{ whiteSpace: 'nowrap' }}>
                {lastWord}
                <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-almost-sold-last-sets'>
                  <strong>{getAlmostSoldOutTooltipText(product.quantity)}</strong>
                </Tooltip>}>
                  <i className='bi bi-info-circle px-1' />
                </OverlayTrigger>
              </span>
            </p>
          );
        })()}
      </div>
    );
  } else if (product.quantity > 0 && product.state === 'SOLD_OUT' && isWishlistPage) {
    return (
      <>
        <p className={`${styleClass} text-info font-weight-bold mb-0`}>Останні набори
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>В наявності останні набори. Товар знятий з продажу і більше не буде поставлятись</strong>
          </Tooltip>}>
            <i className='bi bi-info-circle px-1' />
          </OverlayTrigger>
        </p>
        {product.quantity <= 3 && (() => {
          const t = getAlmostSoldOutText(product.quantity);
          const lastSpace = t.lastIndexOf(' ');
          const beforeLastWord = lastSpace >= 0 ? t.slice(0, lastSpace + 1) : '';
          const lastWord = lastSpace >= 0 ? t.slice(lastSpace + 1) : t;
          return (
            <p className={`${styleClass} text-warning font-weight-bold mb-0 mt-0`}>
              {beforeLastWord}
              <span style={{ whiteSpace: 'nowrap' }}>
                {lastWord}
                <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-almost-sold-last-sets-wishlist'>
                  <strong>{getAlmostSoldOutTooltipText(product.quantity)}</strong>
                </Tooltip>}>
                  <i className='bi bi-info-circle px-1' />
                </OverlayTrigger>
              </span>
            </p>
          );
        })()}
      </>
    );
  } else if (product.quantity > 0 && product.state === 'PREORDER') {
    if (isBasket) {
      return <PreOrderBlock expectedArrivalDate={product.expectedArrivalDate} className={styleClass} />;
    }
    const arrivalDateOrdinal = formatExpectedArrivalDateOrdinal(product.expectedArrivalDate);
    const preorderBadgeText = arrivalDateOrdinal
      ? `Передзамовлення, очікується з ${arrivalDateOrdinal}`
      : 'Передзамовлення';
    const badgeLineClass = styleClass.replace(/\bpb-2\b/g, '').trim();
    return (
      <div className='pb-2'>
        <p className={`${badgeLineClass} text-success font-weight-bold mb-0`}>
          {(() => {
            const lastSpace = preorderBadgeText.lastIndexOf(' ');
            const beforeLastWord = lastSpace >= 0 ? preorderBadgeText.slice(0, lastSpace + 1) : '';
            const lastWord = lastSpace >= 0 ? preorderBadgeText.slice(lastSpace + 1) : preorderBadgeText;
            return (
              <>
                {beforeLastWord}
                <span style={{ whiteSpace: 'nowrap' }}>
                  {lastWord}
                  <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
                    <strong>Товар в передзамовленні{arrivalDateOrdinal ? `, очікується з ${arrivalDateOrdinal}` : ', терміни надходження уточнюйте у менеджера'}</strong>
                  </Tooltip>}>
                    <i className='bi bi-info-circle px-1' />
                  </OverlayTrigger>
                </span>
              </>
            );
          })()}
        </p>
        {product.quantity <= 3 && (() => {
          const t = getAlmostSoldOutText(product.quantity);
          const lastSpace = t.lastIndexOf(' ');
          const beforeLastWord = lastSpace >= 0 ? t.slice(0, lastSpace + 1) : '';
          const lastWord = lastSpace >= 0 ? t.slice(lastSpace + 1) : t;
          return (
            <p className={`${badgeLineClass} text-warning font-weight-bold mb-0 mt-0`}>
              {beforeLastWord}
              <span style={{ whiteSpace: 'nowrap' }}>
                {lastWord}
                <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-almost-sold-preorder'>
                  <strong>{getAlmostSoldOutTooltipText(product.quantity)}</strong>
                </Tooltip>}>
                  <i className='bi bi-info-circle px-1' />
                </OverlayTrigger>
              </span>
            </p>
          );
        })()}
      </div>
    )
  } else if (product.quantity > 0) {
    if (isBasket) {
      return null;
    }
    const badgeLineClass = styleClass.replace(/\bpb-2\b/g, '').trim();
    return (
      <div className='pb-2'>
        <p className={`${badgeLineClass} text-success font-weight-bold mb-0`}>Є в наявності
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>Товар в наявності на нашому складі, відправка протягом 1 робочого дня</strong>
          </Tooltip>}>
            <i className='bi bi-info-circle px-1' />
          </OverlayTrigger>
        </p>
        {product.quantity <= 3 && (() => {
          const t = getAlmostSoldOutText(product.quantity);
          const lastSpace = t.lastIndexOf(' ');
          const beforeLastWord = lastSpace >= 0 ? t.slice(0, lastSpace + 1) : '';
          const lastWord = lastSpace >= 0 ? t.slice(lastSpace + 1) : t;
          return (
            <p className={`${badgeLineClass} text-warning font-weight-bold mb-0 mt-0`}>
              {beforeLastWord}
              <span style={{ whiteSpace: 'nowrap' }}>
                {lastWord}
                <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-almost-sold'>
                  <strong>{getAlmostSoldOutTooltipText(product.quantity)}</strong>
                </Tooltip>}>
                  <i className='bi bi-info-circle px-1' />
                </OverlayTrigger>
              </span>
            </p>
          );
        })()}
      </div>
    )
  }
  else if (product.state === 'OUT_OF_STOCK') {
    if (isBasket) return null;
    const arrivalDate = formatExpectedArrivalDate(product.expectedArrivalDate);
    const showDate = arrivalDate && (product.state === 'PREORDER' || product.quantity === 0);
    return (
      <p className={`${styleClass} text-warning font-weight-bold mb-0`}>
        Тимчасово недоступний
        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
          <strong>Товар відсутній на складі у постачальника{arrivalDate ? `, очікується: ${arrivalDate}` : '. Потрібно очікувати на оновлення асортименту'}</strong>
        </Tooltip>}>
          <i className='bi bi-info-circle px-1' />
        </OverlayTrigger>
        {showDate && (
          <>
            {' · '}
            <span className='text-success'>
              <i className='bi bi-calendar-check mr-1' />
              Очікується з {arrivalDate}
            </span>
          </>
        )}
      </p>
    );
  } else if (product.state === 'ACTIVE' && product.quantity === 0) {
    if (isBasket) return null;
    const arrivalDate = formatExpectedArrivalDate(product.expectedArrivalDate);
    const showDate = arrivalDate && (product.state === 'PREORDER' || product.quantity === 0);
    return (
      <p className={`${styleClass} text-warning font-weight-bold mb-0`}>
        Під замовлення
        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
          <strong>Товар може бути доставлений під замовлення{arrivalDate ? `, очікується: ${arrivalDate}` : '. Терміни і точну вартість уточнюйте в телеграмі або за номером телефону, що вказаний в шапці сайту'}</strong>
        </Tooltip>}>
          <i className='bi bi-info-circle px-1' />
        </OverlayTrigger>
        {showDate && (
          <>
            {' · '}
            <span className='text-success'>
              <i className='bi bi-calendar-check mr-1' />
              Очікується з {arrivalDate}
            </span>
          </>
        )}
      </p>
    );
  } else if (product.state === 'SOLD_OUT') {
    if (isBasket) return null;
    return (
      <p className={`${styleClass} text-danger font-weight-bold`}>Знятий з продажу
        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
          <strong>Товар знятий з продажу і навряд чи буде доступний в майбутньому</strong>
        </Tooltip>}>
          <i className='bi bi-info-circle px-1' />
        </OverlayTrigger>
      </p>
    );
  }
  return null;
};

export default ProductStatus;
